var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, css, html, LitElement } from 'lit-element';
import './product-tile';
import '../services/tc-slider';
import TcSlider from '../services/tc-slider';
let ProductList = class ProductList extends LitElement {
    constructor() {
        super(...arguments);
        this.skus = '';
        this.skusTotal = 0;
        this.products = [];
        this.colorAsProduct = false;
        this.stickersDisabled = false;
        this.sliderConfig = null;
        this.altshopID = '1';
    }
    static get styles() {
        return css ``;
    }
    connectedCallback() {
        super.connectedCallback();
        this.skusTotal = this.skus.split(',').length;
        fetch(`/api/catalog/product?sku=${encodeURIComponent(this.skus)}`, {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({ altshop_id: this.altshopID }),
        })
            .then((res) => {
            if (!res.ok) {
                throw new Error('Invalid response');
            }
            return res.json();
        })
            .then((products) => {
            if (!Array.isArray(products)) {
                products = [products];
            }
            this.products = products;
            this.skusTotal = products.length;
            // Trigger zdarzenia products-show, aby mechanizmy wywołujące product-list mogły sprawdzić, co
            // finalnie zostało wyświetlone
            this.dispatchEvent(new CustomEvent('products-show', {
                detail: {
                    products,
                },
                bubbles: true,
            }));
            const element = this;
            const sliderWrapper = element.shadowRoot ? element.shadowRoot.querySelector('.slider') : null;
            this.updateComplete
                .then(() => {
                if (sliderWrapper) {
                    let settings = {
                        items: 5,
                        start: 0,
                        gutter: 8,
                        showNav: true,
                        breakpoints: [
                            { items: 4, maxWidth: 1000 },
                            { items: 3, maxWidth: 960 },
                            { items: 2, maxWidth: 650 },
                        ],
                    };
                    if (this.sliderConfig !== null) {
                        settings = JSON.parse(this.sliderConfig);
                    }
                    new TcSlider(sliderWrapper, settings);
                }
            })
                .catch((err) => {
                console.log('Failed to initialize slider after update completed', err);
            });
        })
            .catch((err) => {
            console.error('Failed to get products for listing', err);
        });
    }
    render() {
        let cssJsMinHash = null;
        if (typeof window.__STATE__ !== 'undefined') {
            cssJsMinHash = window.__STATE__.system.css_js_min_hash;
        }
        return html ` <style>
                .slider product-tile {
                    display: block;
                }
                .tc-slider .tc-slider__item {
                    height: 425px;
                }
                @media only screen and (max-width: 740px) {
                    .tc-slider .tc-slider__item {
                        height: 460px;
                    }
                }

                @media only screen and (max-width: 650px) {
                    .tc-slider .tc-slider__item {
                        height: 425px;
                    }
                }
            </style>
            <link rel="stylesheet" href="/css/layout/tc-slider.css${cssJsMinHash ? '?t=' + cssJsMinHash : ''}" />
            <div class="slider">
                ${this.products.map((product) => html `
                        <product-tile
                            altshopID="${this.altshopID}"
                            .product=${product}
                            ?colorAsProduct=${this.colorAsProduct}
                            ?stickersDisabled=${this.stickersDisabled}
                            @click=${(e) => {
            // Sprawdzamy, czy kliknięto w link lub przycisk dodawania do koszyka
            let handle = false;
            let cartAdd = false;
            e.composedPath().forEach((elem) => {
                if (elem instanceof HTMLElement &&
                    (elem.tagName === 'A' || elem.tagName === 'CART-ADD')) {
                    handle = true;
                    cartAdd = elem.tagName === 'CART-ADD';
                }
            });
            // Trigger zdarzenia product-click, aby mechanizmy wywołujące product-list mogły sprawdzić, co
            // finalnie zostało wyświetlone
            if (handle) {
                this.dispatchEvent(new CustomEvent('product-click', {
                    detail: {
                        product,
                        cartAdd: cartAdd,
                    },
                    bubbles: true,
                }));
            }
        }}
                        ></product-tile>
                    `)}
            </div>`;
    }
};
__decorate([
    property({ type: String })
], ProductList.prototype, "skus", void 0);
__decorate([
    property({ type: Number })
], ProductList.prototype, "skusTotal", void 0);
__decorate([
    property({ type: Array })
], ProductList.prototype, "products", void 0);
__decorate([
    property({ type: Boolean })
], ProductList.prototype, "colorAsProduct", void 0);
__decorate([
    property({ type: Boolean })
], ProductList.prototype, "stickersDisabled", void 0);
__decorate([
    property({ type: String })
], ProductList.prototype, "sliderConfig", void 0);
__decorate([
    property({ type: String })
], ProductList.prototype, "altshopID", void 0);
ProductList = __decorate([
    customElement('product-list')
], ProductList);
export default ProductList;
